<template>
<div>
  <a-tabs  v-model="customActiveKey" :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }" v-if="edit==false" @change="changeTab">
    <a-tab-pane key="tab1" tab="登录">
      <LoginAccount ref="alogin" @validateFail="validateFail" @success="loginSelectOk" @fail="requestFailed"></LoginAccount>
    </a-tab-pane>
    <a-tab-pane key="tab2" tab="注册">
      <RegisterForm ref="register" @validateFail="validateFail" @ok="loginSelectOk" @fail="requestFailed" @clear="clear"></RegisterForm>
    </a-tab-pane>
    <!-- <a-tab-pane key="2" tab="验证码登录" force-render>Content of Tab Pane 2</a-tab-pane> -->
  </a-tabs>
  <a-form-item v-if="edit==false && select=='tab1'">
    <a class="edit" @click="editpassword">修改密码</a>
  </a-form-item>
  <a-form-item style="margin-left:30px" v-if="edit==false && select=='tab1'">
    <a-button size="large"  type="primary"  htmlType="submit"  class="login-button" style="width:91%;background:#00488a;border:#00488a"   @click.stop.prevent="handleSubmit" >立即登录
    </a-button>
  </a-form-item>
  <a-form-item style="margin-left:30px" v-if="edit==false && select=='tab1'">
    <a-button size="large"  type="primary"    class="login-button" style="width:91%;background:#00488a;border:#00488a"   @click="cancel">取消
    </a-button>
  </a-form-item>

  <a-tabs  :activeKey="customActiveKey" :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }" v-if="edit==true">
    <a-tab-pane key="tab1" tab="修改密码">
      <EditPassword ref="edit" v-if="edit==true"></EditPassword>
    </a-tab-pane>
  </a-tabs>
  <a-form-item v-if="edit==true">
    <span style="color:red;margin-left:26px">* 如忘记密码请联系系统管理员！</span>
    <a class="edit" @click="retlogin">登录</a>
  </a-form-item>
  <a-form-item style="margin-left:30px" v-if="edit==true">
    <a-button size="large"  type="primary"   class="login-button" style="width:91%;background:#00488a;border:#00488a"   @click.stop.prevent="editok" >确定
    </a-button>
  </a-form-item>
  <a-form-item style="margin-left:30px" v-if="edit==true">
    <a-button size="large"  type="primary"    class="login-button" style="width:91%;background:#00488a;border:#00488a"   @click="canceledit">取消
    </a-button>
  </a-form-item>
  <a-form-item  v-if="edit==true">
    <!-- <span style="color:red">* 如忘记密码请联系系统管理员！</span> -->
  </a-form-item>
  </div>
</template>
<script>
import LoginAccount from './LoginAccount'
import EditPassword from './EditPassword.vue'
import RegisterForm from './RegisterForm.vue'
export default {
  components: {
    LoginAccount,
    EditPassword,
    RegisterForm
    },
  data() {
    return {
      login:1,
      activeKey:['1'],
      customActiveKey: 'tab1',
      rememberMe: true,
      loginBtn: false,
      edit:false,
      select:"tab1"
    };
  },
  created(){
    this.edit=false
  },
  methods: {
    refreshCheckCode() {
      if(this.$refs.alogin) {
        this.$refs.alogin.handleChangeCheckCode();
      }
    },
    changeTab(e){
      this.select = e
      this.customActiveKey = e
    },
    editok(){
      this.$refs.edit.handleSubmit()
    },
    retlogin(){
      this.edit=false
    },
    editpassword(){
      this.edit=true
    },
    clear(){
      this.$emit('cancel')
    },
    cancel(){
      this.$refs.alogin.clear()
      this.$emit('cancel')
    },
    canceledit(){
      this.$refs.edit.clear()
      this.edit=false
      this.$emit('cancel')
    },
    passlogin(){
        this.login=1
    },
      //登录
      handleSubmit () {
        this.loginBtn = true;
        if (this.customActiveKey === 'tab1') {
          // 使用账户密码登录
          this.$refs.alogin.handleLogin(this.rememberMe)
        }
        if (this.customActiveKey === 'tab2') {
          // 使用账户密码登录
          this.$refs.register.handleSubmit()
        }
      },
      // 校验失败
      validateFail(){
        this.loginBtn = false;
      },
      // 登录后台成功
      requestSuccess(loginResult){
        this.$refs.loginSelect.show(loginResult)
      },

      loginSelectOk(result){
        if(this.customActiveKey === 'tab1'){
          this.loginSuccess(result)
        }
        if(this.customActiveKey === 'tab2'){
          this.$emit('ok')
        }
      },
      timeFix() {
        const time = new Date()
        const hour = time.getHours()
        return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
      },
      //登录成功
      loginSuccess (result) {
        // this.$router.push({ path: "/home" }).catch(()=>{
        //   console.log('登录跳转首页出错,这个错误从哪里来的')
        // })
        this.$emit('ok',result)
        this.$notification.success({
          message: '欢迎',
          description: `${this.timeFix()}，欢迎回来`,
        });
        this.resetSetItem("islogin", "1");
      },
      requestFailed (err) {
        let description = ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试"
        this.$notification[ 'error' ]({
          message: '登录失败',
          description: description,
          duration: 4,
        });
        //账户密码登录错误后更新验证码
        if(this.customActiveKey === 'tab1' && description.indexOf('密码错误')>0){
          this.$refs.alogin.handleChangeCheckCode()
        }
        this.loginBtn = false;
      },
  },
};
</script>

<style>
.edit{
font-weight:normal;
font-size:16px;
color:#2890ff;
float:right;
margin-right:50px
}
</style>



// WEBPACK FOOTER //
// src/views/login/moudles/UserLogin.vue